import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-datagoogle',
  templateUrl: './page-datagoogle.component.html',
  styleUrls: ['./page-datagoogle.component.css']
})
export class PageDatagoogleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
